import * as yup from 'yup'

import Typography from '@mui/material/Typography'
import { Formik } from 'formik'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import testidKeys from '../../../app/testidKeys'
import { MoovyForm } from '../../../components'
import { isValidLicensePlate } from '../../../utils/validator'

export type OnSubmitCallback = (values: FormValues) => void

export type FormLicensePlateProps = {
  licensePlate: string
  onSubmit: OnSubmitCallback
  formReference: string
}

export interface FormValues {
  licensePlate: string
}

const FormLicensePlate = (props: FormLicensePlateProps) => {
  const intl = useIntl()

  const [formikValidateOnChange, setFormikValidateOnChange] = useState(false)

  const defaultValues = {
    licensePlate: props.licensePlate,
  }
  const validationSchema = () => {
    return yup.object().shape({
      licensePlate: yup
        .string()
        .trim()
        .test(
          'licensePlate',
          intl.formatMessage({
            id: 'page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate',
          }),
          (licensePlate?: string) => isValidLicensePlate(licensePlate),
        ),
    })
  }
  const onSubmitFormValues = (values: FormValues) => {
    const { licensePlate } = values
    props.onSubmit({
      licensePlate: licensePlate.trim(),
    })
  }

  return (
    <>
      <Formik
        validate={() => setFormikValidateOnChange(true)}
        validationSchema={validationSchema()}
        enableReinitialize={true}
        initialValues={defaultValues}
        validateOnChange={formikValidateOnChange}
        onSubmit={(values) => {
          onSubmitFormValues(values)
        }}
      >
        {({ values, errors, handleChange, handleSubmit }) => (
          <form
            onSubmit={(event) => {
              event.preventDefault()
              handleSubmit()
            }}
            id={props.formReference}
            style={{ width: '100%' }}
          >
            <MoovyForm.FormContainer>
              <MoovyForm.FormTextField
                name="licensePlate"
                data-testid={testidKeys.STEP_LICENSE_PLATE_LPN_INPUT}
                value={values.licensePlate}
                autoFocus
                label={intl.formatMessage({
                  id: 'page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter',
                })}
                placeholder={intl.formatMessage({
                  id: 'page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate',
                })}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleChange}
                error={!!errors.licensePlate}
                errorText={errors.licensePlate}
              />
              <Typography variant="body2">
                <FormattedMessage id="page.webPayment.stepFillLicensePlate.formLicensePlate.info.format" />
              </Typography>
            </MoovyForm.FormContainer>
          </form>
        )}
      </Formik>
    </>
  )
}

export default FormLicensePlate
